import ApiHosts from "@/libs/ApiHosts";

/**
 * **자체 결제(PayPal · Eximbay · Inicis)의 배송비** — 카트 라우트(`/api/shops/shipping-price-by-sku`)와
 * GMC 피드(`merchant-feed/shipping.ts`)가 같은 함수를 쓴다.
 *
 * 피드 배송비가 결제 배송비와 다르면 GMC 가 그 상품을 거절한다. 그래서 mgmt `calculate-by-sku` 호출을
 * 복사하지 않고 공유한다. GE 결제 국가의 배송비는 GE 요율표가 정하므로 여기 대상이 아니다.
 *
 * ★**번들 SKU 를 쪼개지 않고 그대로 보낸다**(#5791). mgmt 가 번들 SKU 를 직접 받아 번들 무게로 계산한다
 * (mgmt#1274). 종전엔 `skuOption.skus` 로 구성품을 펼쳐 보냈는데, 글러브 올사이즈 번들이 구성품 합
 * 6.0kg 로 계산돼 번들 무게 4.5kg 보다 배송비가 높게 나왔다(prod AL 2026-10-08: $87 → $73). 같은 날
 * prod 번들 20개를 「그대로 / 펼침」 두 방식으로 물어 차이 나는 것은 글러브 올사이즈 4개뿐이었다.
 * GE 경로(`get-checkout-cart-info.ts`)도 번들 SKU 그대로 묻는다 — 이제 두 경로의 무게가 같다.
 */

/** 한국은 무료 배송 — 네트워크를 타지 않는다(카트 `ShippingApi.calculateShippingPriceBySku` · GMC 피드 공용). */
export function isFreeShippingCountry(countryCode: string): boolean {
  return countryCode.trim().toUpperCase() === "KR";
}

export interface ShippingItemBySku {
  sku: string;
  qty: number;
}

/**
 * mgmt `calculate-by-sku` 를 부른다(배송비는 **항상 USD**) — 응답 그대로 돌려주고 해석은 호출처가 한다
 * (카트 라우트는 상태 코드를 그대로 중계하고, 피드는 실패를 「배송비 없음」으로 접는다).
 */
export function requestOwnShippingPrice({
  countryCode,
  items,
  state,
  zip,
  signal,
}: {
  countryCode: string;
  items: ShippingItemBySku[];
  state?: string;
  zip?: string;
  signal?: AbortSignal;
}): Promise<Response> {
  return fetch(`${ApiHosts.admin}/api/v2/shipping-price/calculate-by-sku`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ countryCode, items, state, zip }),
    signal,
  });
}
